export class Shader {
  public uniforms: string[];
  public attribs: string[];
  public program: WebGLProgram | undefined;

  private _vertSource: string;
  private _fragSource: string;

  constructor(vert: string, frag: string, uniforms: string[], attribs: string[]) {
    this._vertSource = vert;
    this._fragSource = frag;
    this.uniforms = uniforms;
    this.attribs = attribs;
  }

  compileProgram(gl: WebGL2RenderingContext, name: string) {
    const vertexShader = Shader.loadShader(
      gl,
      gl.VERTEX_SHADER,
      this._vertSource,
    );
    const fragmentShader = Shader.loadShader(
      gl,
      gl.FRAGMENT_SHADER,
      this._fragSource,
    );

    // Create the shader program by attaching and linking the shader objects
    const shaderProgram = gl.createProgram();
    if (!shaderProgram) {
      throw new Error("unable to create gl program");
    }
    gl.attachShader(shaderProgram, vertexShader);
    gl.attachShader(shaderProgram, fragmentShader);
    gl.linkProgram(shaderProgram);

    // If creating the shader program failed, throw an error
    if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
      throw new Error(
        `Unable to link the shader program ${name} error:${gl.getProgramInfoLog(shaderProgram)}`,
      );
    }
    this.program = shaderProgram;
  }

  static loadShader(gl: WebGL2RenderingContext, type: GLenum, source: string) {
    const shader = gl.createShader(type);

    if (!shader) {
      throw new Error("unable to create shader of this type");
    }

    // Send the source to the shader object
    gl.shaderSource(shader, source);

    // Compile the shader program
    gl.compileShader(shader);

    // See if it compiled successfully
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      // Fail with an error message
      var typeStr = "";
      if (type === gl.VERTEX_SHADER) {
        typeStr = "VERTEX";
      } else if (type === gl.FRAGMENT_SHADER) {
        typeStr = "FRAGMENT";
      }
      const errMessage =
        "An error occurred compiling the shader: " +
        typeStr +
        " -> " +
        gl.getShaderInfoLog(shader);
      gl.deleteShader(shader);
      throw new Error(errMessage);
    }

    return shader;
  }
}
